import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  data: null,
  error: null,
};

// Slice
const initForNobrandSlice = createSlice({
  name: "initForNobrand",
  initialState,
  reducers: {
    setChatbot() {},
    initChatbot(state) {
      return {
        ...state,
        loading: false,
        loaded: null,
        data: null,
      };
    },

    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { setChatbot, initChatbot, fetchDataSuccess, fetchDataFailure } =
  initForNobrandSlice.actions;

export default initForNobrandSlice.reducer;

//saga
function* fetchDataSaga(action) {
  try {
    const peerIp = yield select((state) => state.peerIp.ip);
    const { headers = {}, apiUrl, data = {} } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });
    const response = yield call(apiService.post, apiUrl, data);
    yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* initForNobrandSaga() {
  yield takeLatest(setChatbot.type, fetchDataSaga);
}
